import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_AI_SIMULATION_STATE,
});

export const discardSimulation = () => ({
  type: types.DISCARD_AI_SIMULATION,
});

export const clearError = () => ({
  type: types.CLEAR_AI_SIMULATION_ERROR,
});

export const startSimulation = ({
  agentId,
  acquisitionOrderId,
  lead,
  mode,
}) => ({
  type: types.START_AI_SIMULATION.REQUEST,
  agentId,
  acquisitionOrderId,
  lead,
  mode,
});

export const startSimulationSuccess = (turn) => ({
  type: types.START_AI_SIMULATION.SUCCESS,
  ...turn,
});

export const startSimulationFailure = (error) => ({
  type: types.START_AI_SIMULATION.FAILURE,
  error,
});

export const replySimulation = (text) => ({
  type: types.REPLY_AI_SIMULATION.REQUEST,
  text,
});

export const replySimulationSuccess = (turn) => ({
  type: types.REPLY_AI_SIMULATION.SUCCESS,
  ...turn,
});

export const replySimulationFailure = (error) => ({
  type: types.REPLY_AI_SIMULATION.FAILURE,
  error,
});

export const advanceSimulation = (minutes) => ({
  type: types.ADVANCE_AI_SIMULATION.REQUEST,
  minutes,
});

export const advanceSimulationSuccess = (turn) => ({
  type: types.ADVANCE_AI_SIMULATION.SUCCESS,
  ...turn,
});

export const advanceSimulationFailure = (error) => ({
  type: types.ADVANCE_AI_SIMULATION.FAILURE,
  error,
});
